import React from "react";

/**
 * Widget Iframe Container
 */
export class GoogleTrendsWidgetContainer extends React.Component {
  render() {
    //use iframe to render the widget
    return <div className="trends-widget-container"></div>;
  }
}
